import { SubCategory } from "../Model/SubCategory";
import { SubCategoryRepository } from "../Repository/SubCategoryRepository";

export interface GetSubCategoryUseCase {
  invoke: () => Promise<SubCategory[]>;
}

export class GetSubCategories implements GetSubCategoryUseCase {
  private subCategoryRepo: SubCategoryRepository;
  constructor(_SubCategoryRepo: SubCategoryRepository) {
    this.subCategoryRepo = _SubCategoryRepo;
  }

  async invoke(){
     
    const getData = await await this.subCategoryRepo.getSubCategories();
    return getData;
  }
}